import {Country} from "../../region/types/Country";
import {getCountryName} from "../../region/utils/get_country_name";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmProperty, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmProductDetail {
    event: "product_detail";
    ecommerce: {
        currencyCode: "PLN";
        detail: {
            products: [IGtmProduct];
        };
    };
}

interface IIdFields {
    name: string;
    id: string;
    home_listing_id: string;
    group_id: string;
}

const gtmProductDetail = (idFields: IIdFields, region: IGtmRegion, vendor: IGtmVendor, offer: IGtmOffer, property: IGtmProperty, country: Country) => {
    const customCountry = getCountryName(country);

    // calculate product
    const product: IGtmProduct = {
        ...calculateGtmDimensions(region, offer, property),
        ...idFields,
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: `${offer.id}/${offer.name}`,
        variant: "na",
        quantity: 1,
        custom_country: customCountry
    };
    // prepare gtm data and hit
    const gtmData: IGtmProductDetail = {
        event: "product_detail",
        ecommerce: {
            currencyCode: "PLN",
            detail: {
                products: [product]
            }
        }
    };
    hitGoogleTagManager(gtmData);
    return true;
};

/**
 * Specific actions
 */
interface IPropertyDetailGtmProperty extends IGtmProperty {
    id: number;
    number: string;
    offer: Omit<IGtmOffer, "region" | "vendor"> & {
        vendor: IGtmVendor;
        region: IGtmRegion;
    };
}
export const gtmProductDetailOnPropertyDetail = (property: IPropertyDetailGtmProperty) => {
    const name = property.number;
    const id = `PR${property.id}`;
    const homeListingId = `${property.offer.id}-${property.id}`;
    const groupId = `${property.offer.id}-0`;
    const offer = property.offer;
    const flatOffer: IGtmOffer = {...offer, region: offer.region.id, vendor: offer.vendor.id};
    const country = offer.region.country;

    return gtmProductDetail({name, id, home_listing_id: homeListingId, group_id: groupId}, offer.region, offer.vendor, flatOffer, property, country);
};
import {Country} from "../../region/types/Country";
import {getCountryName} from "../../region/utils/get_country_name";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmProperty, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmProductDetail {
    event: "product_detail";
    ecommerce: {
        currencyCode: "PLN";
        detail: {
            products: [IGtmProduct];
        };
    };
}

interface IIdFields {
    name: string;
    id: string;
    home_listing_id: string;
    group_id: string;
}

const gtmProductDetail = (idFields: IIdFields, region: IGtmRegion, vendor: IGtmVendor, offer: IGtmOffer, property: IGtmProperty, country: Country) => {
    const customCountry = getCountryName(country);

    // calculate product
    const product: IGtmProduct = {
        ...calculateGtmDimensions(region, offer, property),
        ...idFields,
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: `${offer.id}/${offer.name}`,
        variant: "na",
        quantity: 1,
        custom_country: customCountry
    };
    // prepare gtm data and hit
    const gtmData: IGtmProductDetail = {
        event: "product_detail",
        ecommerce: {
            currencyCode: "PLN",
            detail: {
                products: [product]
            }
        }
    };
    hitGoogleTagManager(gtmData);
    return true;
};

/**
 * Specific actions
 */
interface IPropertyDetailGtmProperty extends IGtmProperty {
    id: number;
    number: string;
    offer: Omit<IGtmOffer, "region" | "vendor"> & {
        vendor: IGtmVendor;
        region: IGtmRegion;
    };
}
export const gtmProductDetailOnPropertyDetail = (property: IPropertyDetailGtmProperty) => {
    const name = property.number;
    const id = `PR${property.id}`;
    const homeListingId = `${property.offer.id}-${property.id}`;
    const groupId = `${property.offer.id}-0`;
    const offer = property.offer;
    const flatOffer: IGtmOffer = {...offer, region: offer.region.id, vendor: offer.vendor.id};
    const country = offer.region.country;

    return gtmProductDetail({name, id, home_listing_id: homeListingId, group_id: groupId}, offer.region, offer.vendor, flatOffer, property, country);
};
